import Vue from 'vue'
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)
import { languages } from '../locales/index'
const messages = Object.assign(languages)
export default new  VueI18n({
  locale: 'en',
  fallbackLocale: 'en',
  messages
})